var React = require('react');

function Documentation (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#677581","strokeWidth":"1.5","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M19.5 6a1 1 0 0 0-1-1h-4.25a2 2 0 0 0-2 2v12.5l.828-.828a4 4 0 0 1 2.829-1.172H18.5a1 1 0 0 0 1-1V6zM5 6a1 1 0 0 1 1-1h4.25a2 2 0 0 1 2 2v12.5l-.828-.828A4 4 0 0 0 8.593 17.5H6a1 1 0 0 1-1-1V6z"})));
}

Documentation.defaultProps = {"width":"24","height":"24"};

module.exports = Documentation;

Documentation.default = Documentation;
